// Packages grid section scaffold (collection layout for packages).
import PackageCard from "./PackageCard";

export default function PackagesGrid({ packages }) {
  return (
    <div className="packages-grid">
      {packages.map((pkg, idx) => (
        <PackageCard
          key={idx}
          index={idx}
          name={pkg.name}
          desc={pkg.desc}
          sections={pkg.sections}
          ctaText={pkg.cta}
        />
      ))}
    </div>
  );
}

